import React, { useState, useEffect } from 'react'
import Seguro1 from '../../../../assets/CCImages/seguro1.jpg'
import Seguro2 from '../../../../assets/CCImages/seguro2.png'
import { useStyles } from '../styles'
import { Checkbox, Typography, useMediaQuery } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedInsurance } from '../store'

const Insurance = () => {
  const classes = useStyles()
  const isSmallScreen = useMediaQuery('(max-width:636px)')
  const dispatch = useDispatch()
  const { insuranceList, selectedInsurance } = useSelector( (state) => state.creditLimitRequest )

  // console.log("selectedInsurance", selectedInsurance)

  // Local state for selected insurances
  const [selectedInsurances, setSelectedInsurances] = useState([])
  let disabled  = { }

  // Single useEffect to handle all initialization logic
  React.useEffect(() => {
    if (selectedInsurance) {
      if (Array.isArray(selectedInsurance)) {
        setSelectedInsurances(selectedInsurance)
      } else if (selectedInsurance.id && selectedInsurance.title === null && insuranceList?.length > 0) {
        const currentIns = insuranceList.find(item => item.insuranceOptionID === selectedInsurance.id)
        if (currentIns) {
          const newSelection = [currentIns]
          setSelectedInsurances(newSelection)
          dispatch(setSelectedInsurance(newSelection))
        }
      }
    }
  }, [selectedInsurance, insuranceList, dispatch])

  // Handle toggle selections
  const handleInsuranceSelection = (item) => {
    let newSelected = [...selectedInsurances]
    const isAlreadySelected = newSelected.some(insurance => insurance.insuranceOptionID === item.insuranceOptionID)

    if (isAlreadySelected) {
      // Remove from selection
      newSelected = newSelected.filter(insurance => insurance.insuranceOptionID !== item.insuranceOptionID)
      if (item?.requiredInsurances) {
        const insuranceFromAPI = insuranceList.find(insurance => insurance.insuranceOptionID === item?.requiredInsurances)
        newSelected = newSelected.filter(insurance => insurance.insuranceOptionID !== insuranceFromAPI?.insuranceOptionID)
      }
    } else {
      newSelected.push(item)
      if (item?.requiredInsurances) {
        const insuranceFromAPI = insuranceList.find(insurance => insurance.insuranceOptionID === item?.requiredInsurances)
        newSelected.push(insuranceFromAPI)
      }

    }

    setSelectedInsurances(newSelected)
    dispatch(setSelectedInsurance(newSelected))
  }

  // Check if an insurance is selected
  const isInsuranceSelected = (insuranceOptionID) => {

    if (disabled[insuranceOptionID]) {
      return true
    }

    const isSelected = selectedInsurances.some( insurance => insurance.insuranceOptionID === insuranceOptionID )
    const insuranceFromAPI = insuranceList.find( insurance => insurance.insuranceOptionID === insuranceOptionID )

    // console.log('selectedInsurances', selectedInsurances, insuranceOptionID, "insuranceFromAPI", insuranceFromAPI)
    if (isSelected && insuranceFromAPI) {
      const insuranceRequiredID = insuranceFromAPI?.requiredInsurances
      if (insuranceRequiredID) {
        disabled = { ...disabled, [insuranceRequiredID]: true }
      } else disabled = { ...disabled, [insuranceRequiredID]: false }
    }

    return isSelected ? true : false
  }

  const getInsuranceImage = (insuranceOptionID) => {
    return insuranceOptionID === 1 ? Seguro1 : Seguro2
  }

  const hasInsuranceOptions = insuranceList?.length > 0

  return (
    <div>
      {hasInsuranceOptions && (
        <React.Fragment>
          <div className={classes.ButtonTitle}>Insurance</div>

          <Typography color={'#666C89'}>
            Life insurance for Credit Cards is an insurance product that is designed
            to offer coverage if a defined event such as death or a covered critical
            illness occurs. Critical illness includes heart attack, stroke, and
            life-threatening cancer.
            <br /> <br />
            This insurance can easily pay off all or a part of your outstanding
            credit card balance, relieving your loved ones of that added financial
            pressure. <br /> <br />
            Do you wish to add insurance coverage for the credit card you are
            applying for?
          </Typography>
        </React.Fragment>
      )}

      {insuranceList?.map((item, index) => (
        <div
          key={`insurance-option-${item.insuranceOptionID || index}`}
          style={{
            border: isInsuranceSelected(item.insuranceOptionID)
              ? '3px solid #2F80ED'
              : '1px solid rgba(0,0,0,0.5)'
          }}
          className={classes.InsuranceContainer}
          onClick={() => disabled[item.insuranceOptionID] ? null : handleInsuranceSelection(item)}
        >
          <img
            src={getInsuranceImage(item.insuranceOptionID)}
            alt={`${item.title} representation`}
          />

          <div>
            <Typography color={'#091242'} fontSize={20} fontWeight={600}>
              {item.title}
            </Typography>
            <Typography color={'#666C89'}>{item.description}</Typography>
            <ul>
              <li>
                <Typography color={'#666C89'}>{item.firstBullet}</Typography>
              </li>
              <li>
                <Typography color={'#666C89'}>{item.secondBullet} </Typography>
              </li>
            </ul>
          </div>
          {disabled[item.insuranceOptionID] && (
            <Typography
              color={'#37393F'}
              fontSize={isSmallScreen ? 12 : 16}
              style={{
                position: 'absolute',
                top: isSmallScreen ? 5 : 12,
                left: isSmallScreen ? 5 : 12,
                padding: '0.5rem',
                backgroundColor: '#FFD6D6', // color claro informativo
                borderRadius: '12px',
                zIndex: 1
              }}>
              This insurance is required
            </Typography>
          )}
          <Checkbox
            onChange={() => {}}
            disabled={disabled[item.insuranceOptionID]}
            checked={isInsuranceSelected(item.insuranceOptionID)}
            style={{
              position: 'absolute',
              top: isSmallScreen ? 5 : 12,
              right: isSmallScreen ? 5 : 12,
              padding: 0
            }}
          />
        </div>
      ))}

      {hasInsuranceOptions && (
        <div
          style={{
            backgroundColor: '#FFD6D6',
            padding: '2rem',
            borderRadius: '8px',
            margin: '2rem 0',
            textAlign: 'center'
          }}
        >
          <Typography color={'#37393F'}>
            Maximum Coverage: BZ $ 30,000.
          </Typography>
        </div>
      )}
    </div>
  )
}

export default Insurance
